/**
 * @generated SignedSource<<0ed52e2ee3c31551c9097d7f51044a6c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TrackViewEvent = "DIRECT" | "INDIRECT" | "SKIP";
export type GoalViewAsideQuery$variables = {
  containerId: string;
  isNavRefreshEnabled: boolean;
  key: string;
  teamTql?: string | null;
  trackViewEvent?: TrackViewEvent | null;
};
export type GoalViewAsideQuery$data = {
  readonly goal?: {
    readonly owner: {
      readonly aaid: string | null;
    } | null;
    readonly watchers: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly aaid: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"GoalMetaActions" | "GoalSidebar">;
  } | null;
  readonly workspaceGoalTypes: {
    readonly goalTypes: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "GoalType";
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"metricInfoSectionNewLozenge">;
};
export type GoalViewAsideQuery = {
  response: GoalViewAsideQuery$data;
  variables: GoalViewAsideQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isNavRefreshEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamTql"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trackViewEvent"
},
v5 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "containerId"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  },
  {
    "kind": "Variable",
    "name": "trackViewEvent",
    "variableName": "trackViewEvent"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v9 = [
  (v8/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "key"
},
v12 = {
  "kind": "ScalarField",
  "name": "name"
},
v13 = {
  "kind": "ScalarField",
  "name": "picture"
},
v14 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v15 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v16 = {
  "kind": "ScalarField",
  "name": "count"
},
v17 = {
  "kind": "ScalarField",
  "name": "value"
},
v18 = {
  "kind": "ScalarField",
  "name": "score"
},
v19 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v20 = {
  "kind": "ScalarField",
  "name": "watching"
},
v21 = {
  "kind": "ScalarField",
  "name": "archived"
},
v22 = {
  "concreteType": "GoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v23 = {
  "kind": "ScalarField",
  "name": "type"
},
v24 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v25 = {
  "concreteType": "GoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    (v24/*: any*/)
  ]
},
v26 = {
  "concreteType": "MetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v10/*: any*/)
  ]
},
v27 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v28 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v29 = {
  "kind": "ScalarField",
  "name": "subType"
},
v30 = {
  "concreteType": "MetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "MetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "MetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v26/*: any*/),
            (v27/*: any*/),
            (v28/*: any*/),
            {
              "concreteType": "Metric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v23/*: any*/),
                (v29/*: any*/),
                (v10/*: any*/),
                (v12/*: any*/),
                (v21/*: any*/)
              ]
            },
            (v10/*: any*/)
          ]
        }
      ]
    }
  ]
},
v31 = [
  (v16/*: any*/)
],
v32 = {
  "concreteType": "GoalConnection",
  "kind": "LinkedField",
  "name": "subGoals",
  "plural": false,
  "selections": (v31/*: any*/)
},
v33 = {
  "kind": "ScalarField",
  "name": "requiresParentGoal"
},
v34 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v35 = {
  "kind": "ScalarField",
  "name": "messageId"
},
v36 = [
  (v35/*: any*/)
],
v37 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v36/*: any*/)
},
v38 = {
  "kind": "ScalarField",
  "name": "label"
},
v39 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v40 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "confidence"
    },
    (v38/*: any*/),
    (v37/*: any*/),
    {
      "alias": "tooltip",
      "args": (v39/*: any*/),
      "kind": "ScalarField",
      "name": "label",
      "storageKey": "label(longFormat:true)"
    },
    {
      "alias": "localizedTooltip",
      "args": (v39/*: any*/),
      "concreteType": "LocalizationField",
      "kind": "LinkedField",
      "name": "localizedLabel",
      "plural": false,
      "selections": (v36/*: any*/),
      "storageKey": "localizedLabel(longFormat:true)"
    },
    {
      "kind": "ScalarField",
      "name": "overdue"
    }
  ]
},
v41 = {
  "concreteType": "UserPII",
  "kind": "LinkedField",
  "name": "pii",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v15/*: any*/)
  ]
},
v42 = {
  "kind": "ScalarField",
  "name": "__id"
},
v43 = {
  "kind": "ClientExtension",
  "selections": [
    (v42/*: any*/)
  ]
},
v44 = {
  "alias": "connectionId",
  "kind": "ScalarField",
  "name": "__id"
},
v45 = {
  "kind": "ScalarField",
  "name": "ari"
},
v46 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v17/*: any*/)
      ],
      "type": "GoalTypeCustomName"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v35/*: any*/),
        {
          "kind": "ScalarField",
          "name": "defaultValue"
        }
      ],
      "type": "LocalizationField"
    }
  ]
},
v47 = {
  "concreteType": "GoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v11/*: any*/)
  ]
},
v48 = {
  "kind": "ScalarField",
  "name": "description"
},
v49 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v50 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v51 = {
  "kind": "LinkedField",
  "name": "definition",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v12/*: any*/),
        (v48/*: any*/)
      ],
      "type": "CustomFieldDefinitionNode",
      "abstractKey": "__isCustomFieldDefinitionNode"
    },
    (v50/*: any*/)
  ]
},
v52 = {
  "kind": "InlineFragment",
  "selections": [
    (v23/*: any*/)
  ],
  "type": "CustomFieldDefinitionNode",
  "abstractKey": "__isCustomFieldDefinitionNode"
},
v53 = {
  "kind": "ScalarField",
  "name": "canSetMultipleValues"
},
v54 = [
  (v53/*: any*/)
],
v55 = {
  "kind": "InlineFragment",
  "selections": (v54/*: any*/),
  "type": "UserCustomFieldDefinition"
},
v56 = {
  "kind": "InlineFragment",
  "selections": (v54/*: any*/),
  "type": "TextSelectCustomFieldDefinition"
},
v57 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "definition",
      "plural": false,
      "selections": [
        (v52/*: any*/),
        (v55/*: any*/),
        (v56/*: any*/)
      ]
    }
  ],
  "type": "CustomFieldNode",
  "abstractKey": "__isCustomFieldNode"
},
v58 = {
  "kind": "ClientExtension",
  "selections": [
    (v44/*: any*/)
  ]
},
v59 = [
  (v10/*: any*/),
  (v17/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalViewAsideQuery",
    "selections": [
      {
        "alias": "workspaceGoalTypes",
        "concreteType": "Townsquare",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "GoalTypeConnection",
            "kind": "LinkedField",
            "name": "goalTypes",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "GoalType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isNavRefreshEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "goal",
            "args": (v7/*: any*/),
            "concreteType": "Goal",
            "kind": "LinkedField",
            "name": "goalByKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": (v9/*: any*/)
              },
              {
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "watchers",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v9/*: any*/)
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalMetaActions"
              },
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "teamTql",
                    "variableName": "teamTql"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "GoalSidebar"
              }
            ]
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "metricInfoSectionNewLozenge"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalViewAsideQuery",
    "selections": [
      {
        "alias": "workspaceGoalTypes",
        "concreteType": "Townsquare",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "GoalTypeConnection",
            "kind": "LinkedField",
            "name": "goalTypes",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "GoalType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v10/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "keys": [
                    "GOALS_METRICS_POPUP"
                  ]
                }
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              }
            ],
            "concreteType": "OnboardingConnection",
            "kind": "LinkedField",
            "name": "onboarding",
            "plural": false,
            "selections": [
              {
                "concreteType": "OnboardingEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Onboarding",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v10/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "onboarding(filter:{\"keys\":[\"GOALS_METRICS_POPUP\"]},first:1)"
          },
          (v10/*: any*/)
        ]
      },
      {
        "condition": "isNavRefreshEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "goal",
            "args": (v7/*: any*/),
            "concreteType": "Goal",
            "kind": "LinkedField",
            "name": "goalByKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v10/*: any*/),
                  {
                    "concreteType": "UserPII",
                    "kind": "LinkedField",
                    "name": "pii",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "email"
                      },
                      (v15/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "watchers",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v10/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v15/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v16/*: any*/)
                ]
              },
              (v11/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canPostUpdate"
              },
              {
                "concreteType": "GoalState",
                "kind": "LinkedField",
                "name": "state",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v18/*: any*/)
                ]
              },
              (v10/*: any*/),
              {
                "kind": "ScalarField",
                "name": "targetDate"
              },
              {
                "kind": "ScalarField",
                "name": "targetDateConfidence"
              },
              (v19/*: any*/),
              (v20/*: any*/),
              (v12/*: any*/),
              (v21/*: any*/),
              {
                "concreteType": "Goal",
                "kind": "LinkedField",
                "name": "parentGoal",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v25/*: any*/),
                  (v30/*: any*/),
                  (v32/*: any*/),
                  (v12/*: any*/),
                  (v11/*: any*/)
                ]
              },
              {
                "concreteType": "GoalConnection",
                "kind": "LinkedField",
                "name": "subGoals",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v10/*: any*/),
                          (v19/*: any*/),
                          (v11/*: any*/),
                          (v22/*: any*/),
                          (v12/*: any*/),
                          {
                            "concreteType": "GoalProgress",
                            "kind": "LinkedField",
                            "name": "progress",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/),
                              (v23/*: any*/)
                            ]
                          },
                          (v30/*: any*/),
                          (v32/*: any*/),
                          {
                            "concreteType": "GoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              (v33/*: any*/),
                              (v10/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "GoalState",
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": [
                              (v34/*: any*/),
                              (v37/*: any*/),
                              (v18/*: any*/),
                              {
                                "alias": "goalStateValue",
                                "kind": "ScalarField",
                                "name": "value"
                              },
                              {
                                "concreteType": "CompletionGoalState",
                                "kind": "LinkedField",
                                "name": "atCompletionState",
                                "plural": false,
                                "selections": [
                                  (v34/*: any*/),
                                  (v37/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v40/*: any*/),
                          {
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v41/*: any*/),
                              (v10/*: any*/)
                            ]
                          },
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 200
                              },
                              {
                                "kind": "Literal",
                                "name": "tql",
                                "value": "archived = false"
                              }
                            ],
                            "concreteType": "ProjectConnection",
                            "kind": "LinkedField",
                            "name": "projects",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "ProjectEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Project",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      {
                                        "concreteType": "ProjectPhaseDetails",
                                        "kind": "LinkedField",
                                        "name": "newPhase",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": "_id",
                                            "kind": "ScalarField",
                                            "name": "id"
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "owner",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          (v8/*: any*/),
                                          (v41/*: any*/)
                                        ]
                                      },
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      (v19/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "private"
                                      },
                                      {
                                        "concreteType": "IconURIs",
                                        "kind": "LinkedField",
                                        "name": "iconUrl",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "ThemeURIs",
                                            "kind": "LinkedField",
                                            "name": "square",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "light"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "dark"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "transparent"
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v40/*: any*/),
                                      {
                                        "concreteType": "ProjectState",
                                        "kind": "LinkedField",
                                        "name": "state",
                                        "plural": false,
                                        "selections": [
                                          (v38/*: any*/),
                                          (v37/*: any*/),
                                          {
                                            "alias": "projectStateValue",
                                            "kind": "ScalarField",
                                            "name": "value"
                                          },
                                          {
                                            "concreteType": "CompletionProjectState",
                                            "kind": "LinkedField",
                                            "name": "atCompletionState",
                                            "plural": false,
                                            "selections": [
                                              (v17/*: any*/),
                                              (v38/*: any*/),
                                              (v37/*: any*/)
                                            ]
                                          },
                                          (v17/*: any*/)
                                        ]
                                      },
                                      (v21/*: any*/),
                                      {
                                        "concreteType": "UserConnection",
                                        "kind": "LinkedField",
                                        "name": "members",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "UserEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "User",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v8/*: any*/),
                                                  (v10/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v43/*: any*/)
                                ]
                              },
                              (v43/*: any*/)
                            ],
                            "storageKey": "projects(first:200,tql:\"archived = false\")"
                          }
                        ]
                      }
                    ]
                  },
                  (v16/*: any*/),
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      (v42/*: any*/),
                      (v44/*: any*/)
                    ]
                  }
                ]
              },
              (v45/*: any*/),
              {
                "concreteType": "GoalType",
                "kind": "LinkedField",
                "name": "goalType",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "canLinkToFocusArea"
                  },
                  {
                    "concreteType": "GoalTypeConnection",
                    "kind": "LinkedField",
                    "name": "allowedParentTypes",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GoalTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "GoalType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v45/*: any*/),
                              (v46/*: any*/),
                              (v47/*: any*/),
                              (v33/*: any*/),
                              (v10/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "GoalTypeConnection",
                    "kind": "LinkedField",
                    "name": "allowedChildTypes",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GoalTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "GoalType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v45/*: any*/),
                              (v46/*: any*/),
                              (v47/*: any*/),
                              (v33/*: any*/),
                              (v10/*: any*/),
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v33/*: any*/),
                  (v46/*: any*/),
                  (v47/*: any*/)
                ]
              },
              {
                "concreteType": "TagConnection",
                "kind": "LinkedField",
                "name": "tags",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TagEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Tag",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v19/*: any*/),
                          (v12/*: any*/),
                          (v48/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "projectUsageCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "goalUsageCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "helpPointerUsageCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "watcherCount"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": "tagConnectionId",
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  }
                ]
              },
              (v25/*: any*/),
              {
                "concreteType": "MetricTargetConnection",
                "kind": "LinkedField",
                "name": "metricTargets",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "MetricTargetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "MetricTarget",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "Metric",
                            "kind": "LinkedField",
                            "name": "metric",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v10/*: any*/),
                              (v23/*: any*/),
                              (v29/*: any*/),
                              (v12/*: any*/),
                              (v19/*: any*/)
                            ]
                          },
                          (v10/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canEditMembers"
              },
              {
                "args": (v49/*: any*/),
                "concreteType": "GoalTeamConnection",
                "kind": "LinkedField",
                "name": "teamsV2",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalTeamEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "teamId"
                          },
                          (v12/*: any*/),
                          (v10/*: any*/),
                          (v20/*: any*/),
                          {
                            "concreteType": "TeamDetails",
                            "kind": "LinkedField",
                            "name": "teamDetails",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isVerified"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "avatarUrl"
                          },
                          {
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "tql",
                                "variableName": "teamTql"
                              }
                            ],
                            "concreteType": "ProjectConnection",
                            "kind": "LinkedField",
                            "name": "projects",
                            "plural": false,
                            "selections": (v31/*: any*/)
                          },
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canRemove"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  },
                  (v43/*: any*/)
                ],
                "storageKey": "teamsV2(first:20)"
              },
              {
                "args": (v49/*: any*/),
                "handle": "connection",
                "key": "Goal__teamsV2",
                "kind": "LinkedHandle",
                "name": "teamsV2"
              },
              {
                "kind": "ScalarField",
                "name": "startDate"
              },
              {
                "kind": "ScalarField",
                "name": "creationDate"
              },
              {
                "concreteType": "CustomFieldConnection",
                "kind": "LinkedField",
                "name": "customFields",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "CustomFieldEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v51/*: any*/),
                              {
                                "concreteType": "CustomFieldTextSavedValueNode",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "alias": "textValue",
                                    "kind": "ScalarField",
                                    "name": "value"
                                  }
                                ]
                              },
                              (v57/*: any*/)
                            ],
                            "type": "TextCustomField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v51/*: any*/),
                              {
                                "concreteType": "CustomFieldNumberSavedValueNode",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "alias": "numberValue",
                                    "kind": "ScalarField",
                                    "name": "value"
                                  }
                                ]
                              },
                              (v57/*: any*/)
                            ],
                            "type": "NumberCustomField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "definition",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v12/*: any*/),
                                      (v48/*: any*/),
                                      (v53/*: any*/)
                                    ],
                                    "type": "UserCustomFieldDefinition"
                                  },
                                  (v50/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "UserConnection",
                                "kind": "LinkedField",
                                "name": "values",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "UserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          (v8/*: any*/),
                                          {
                                            "concreteType": "UserPII",
                                            "kind": "LinkedField",
                                            "name": "pii",
                                            "plural": false,
                                            "selections": [
                                              (v13/*: any*/),
                                              (v12/*: any*/),
                                              (v14/*: any*/),
                                              (v15/*: any*/),
                                              {
                                                "concreteType": "ExtendedProfile",
                                                "kind": "LinkedField",
                                                "name": "extendedProfile",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "jobTitle"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v58/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "definition",
                                    "plural": false,
                                    "selections": [
                                      (v52/*: any*/),
                                      (v56/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "CustomFieldNode",
                                "abstractKey": "__isCustomFieldNode"
                              }
                            ],
                            "type": "UserCustomField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "definition",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v12/*: any*/),
                                      (v48/*: any*/),
                                      (v53/*: any*/),
                                      {
                                        "concreteType": "CustomFieldTextAllowedValueConnection",
                                        "kind": "LinkedField",
                                        "name": "allowedValues",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "CustomFieldTextAllowedValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "CustomFieldTextAllowedValueNode",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v59/*: any*/)
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "TextSelectCustomFieldDefinition"
                                  },
                                  (v50/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "CustomFieldTextSavedValueConnection",
                                "kind": "LinkedField",
                                "name": "values",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CustomFieldTextSavedValueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldTextSavedValueNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v59/*: any*/)
                                      }
                                    ]
                                  },
                                  (v58/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "definition",
                                    "plural": false,
                                    "selections": [
                                      (v52/*: any*/),
                                      (v55/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "CustomFieldNode",
                                "abstractKey": "__isCustomFieldNode"
                              }
                            ],
                            "type": "TextSelectCustomField"
                          },
                          (v50/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ed67bd470c9cad21a7f64549496bd80e",
    "id": null,
    "metadata": {},
    "name": "GoalViewAsideQuery",
    "operationKind": "query",
    "text": "query GoalViewAsideQuery(\n  $key: String!\n  $trackViewEvent: TrackViewEvent\n  $teamTql: String\n  $isNavRefreshEnabled: Boolean!\n  $containerId: String!\n) {\n  workspaceGoalTypes: townsquare {\n    goalTypes(containerId: $containerId) {\n      edges {\n        node {\n          __typename\n          id\n        }\n      }\n    }\n  }\n  goal: goalByKey(key: $key, trackViewEvent: $trackViewEvent) @include(if: $isNavRefreshEnabled) {\n    owner {\n      aaid\n      id\n    }\n    watchers {\n      edges {\n        node {\n          aaid\n          id\n        }\n      }\n    }\n    ...GoalMetaActions\n    ...GoalSidebar_1QTvbf\n    id\n  }\n  ...metricInfoSectionNewLozenge\n}\n\nfragment AddOrEditButton on CustomFieldNode {\n  __isCustomFieldNode: __typename\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      type\n    }\n    ... on UserCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on TextSelectCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment CompactGoalSummaryPanel on Goal {\n  ...GoalName\n  state {\n    ...GoalState\n  }\n  ...progressBarMetricTarget\n  ...progressText\n  ...hasMetric\n}\n\nfragment ContributingProjectsSummary on ProjectConnection {\n  edges {\n    node {\n      archived\n      owner {\n        aaid\n        id\n      }\n      members {\n        edges {\n          node {\n            aaid\n            id\n          }\n        }\n      }\n      state {\n        value\n      }\n      id\n    }\n  }\n}\n\nfragment FollowersSidebarSection on UserConnection {\n  count\n  edges {\n    node {\n      pii {\n        name\n        picture\n        accountId\n      }\n      id\n    }\n  }\n}\n\nfragment FollowersSidebarSection_GoalKey on Goal {\n  key\n}\n\nfragment FollowersSidebarSection_Owner on UserPII {\n  accountId\n}\n\nfragment FreeformNumberField on NumberCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      name\n      description\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  value {\n    id\n    numberValue: value\n  }\n}\n\nfragment FreeformTextField on TextCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      name\n      description\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  value {\n    id\n    textValue: value\n  }\n}\n\nfragment GoalActions on Goal {\n  id\n  name\n  archived\n  parentGoal {\n    id\n  }\n  subGoals {\n    edges {\n      node {\n        archived\n        id\n      }\n    }\n  }\n}\n\nfragment GoalDatePicker on Goal {\n  id\n  canPostUpdate\n  state {\n    value\n  }\n  targetDate\n  targetDateConfidence\n}\n\nfragment GoalFollowButton on Goal {\n  id\n  uuid\n  watching\n}\n\nfragment GoalItem on Goal {\n  ...PlatformGoalIcon\n  ...progressBarMetricTarget\n  ...metricTargetPopup\n  progress {\n    percentage\n  }\n  name\n  key\n  id\n}\n\nfragment GoalMetaActions on Goal {\n  key\n  ...GoalStateAndTargetDate\n  ...GoalFollowButton\n  ...GoalActions\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment GoalOwner on Goal {\n  id\n  canEditMembers\n  owner {\n    aaid\n    pii {\n      name\n      picture\n      accountStatus\n      email\n    }\n    ...UserAvatar\n    id\n  }\n}\n\nfragment GoalProjects on Goal {\n  id\n  archived\n  projects(tql: \"archived = false\", first: 200) {\n    edges {\n      node {\n        id\n      }\n    }\n    ...ProjectTable\n    ...ContributingProjectsSummary\n  }\n  ...LinkGoalProject\n}\n\nfragment GoalSidebar_1QTvbf on Goal {\n  ari\n  id\n  key\n  goalType {\n    id\n    canLinkToFocusArea\n  }\n  tags {\n    ...Tags\n  }\n  ...parentGoalTypeRestrictions_GoalSidebar\n  ...subGoalTypeRestrictions_GoalSidebar\n  ...metricInfoSection\n  ...GoalOwner\n  ...ParentGoal\n  ...SubGoals\n  ...Teams_1QTvbf\n  ...FollowersSidebarSection_GoalKey\n  ...GoalStartDate\n  ...GoalType\n  customFields {\n    ...SidebarFields\n  }\n  watchers {\n    ...FollowersSidebarSection\n  }\n  owner {\n    pii {\n      ...FollowersSidebarSection_Owner\n    }\n    id\n  }\n}\n\nfragment GoalStartDate on Goal {\n  startDate\n  ...GoalStartDatePicker\n}\n\nfragment GoalStartDatePicker on Goal {\n  id\n  startDate\n  targetDate\n  creationDate\n  state {\n    value\n  }\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  goalStateValue: value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment GoalStateAndTargetDate on Goal {\n  canPostUpdate\n  state {\n    value\n    score\n  }\n  ...GoalDatePicker\n}\n\nfragment GoalSubGoals on Goal {\n  id\n  ari\n  subGoals {\n    edges {\n      node {\n        id\n        archived\n        ...GoalSummaryPanel\n        ...CompactGoalSummaryPanel\n        ...GoalProjects\n      }\n    }\n  }\n}\n\nfragment GoalSummaryPanel on Goal {\n  ...GoalName\n  state {\n    ...GoalState\n  }\n  dueDate {\n    ...TargetDate\n  }\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n  ...progressBarMetricTarget\n  ...progressText\n  ...hasMetric\n}\n\nfragment GoalTeamByline_1QTvbf on Team {\n  teamId\n  projects(tql: $teamTql) {\n    count\n  }\n}\n\nfragment GoalType on Goal {\n  goalType {\n    ...goalTypeName\n    ...PlatformGoalTypeIcon\n    id\n  }\n}\n\nfragment LinkGoalProject on Goal {\n  id\n  projects(tql: \"archived = false\", first: 200) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment ParentGoal on Goal {\n  id\n  ari\n  parentGoal {\n    id\n    archived\n    ...GoalItem\n  }\n  goalType {\n    requiresParentGoal\n    id\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment PlatformGoalTypeIcon on GoalType {\n  icon {\n    key\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  projectStateValue: value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectTable on ProjectConnection {\n  edges {\n    node {\n      id\n      newPhase {\n        _id: id\n      }\n      ...ProjectTableRow\n      ...ProjectTableCompactRow\n    }\n  }\n}\n\nfragment ProjectTableCompactRow on Project {\n  id\n  key\n  name\n  state {\n    ...ProjectState\n  }\n  ...ProjectIcon\n}\n\nfragment ProjectTableRow on Project {\n  id\n  owner {\n    id\n    ...UserAvatar_2aqwkz\n  }\n  ...ProjectName_data\n  dueDate {\n    ...TargetDate\n  }\n  state {\n    ...ProjectState\n  }\n}\n\nfragment RemoveTeam on GoalTeamEdge {\n  canRemove\n  node {\n    teamId\n    id\n  }\n}\n\nfragment RollupMetricForm on Goal {\n  subGoals {\n    edges {\n      node {\n        archived\n        ...GoalName\n        id\n      }\n    }\n  }\n}\n\nfragment SelectField on TextSelectCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on TextSelectCustomFieldDefinition {\n      name\n      description\n      canSetMultipleValues\n      allowedValues {\n        edges {\n          node {\n            id\n            value\n          }\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    edges {\n      node {\n        id\n        value\n      }\n    }\n  }\n}\n\nfragment SidebarFields on CustomFieldConnection {\n  edges {\n    node {\n      __typename\n      ... on TextCustomField {\n        ...FreeformTextField\n      }\n      ... on NumberCustomField {\n        ...FreeformNumberField\n      }\n      ... on UserCustomField {\n        ...UserField\n      }\n      ... on TextSelectCustomField {\n        ...SelectField\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment SubGoals on Goal {\n  id\n  ari\n  goalType {\n    allowedChildTypes {\n      edges {\n        node {\n          __typename\n          id\n        }\n      }\n    }\n    id\n  }\n  subGoals {\n    edges {\n      node {\n        id\n        archived\n        ...GoalItem\n        goalType {\n          requiresParentGoal\n          id\n        }\n      }\n    }\n  }\n  ...GoalSubGoals\n}\n\nfragment Tag on Tag {\n  ...Tag_createTagOption\n}\n\nfragment Tag_createTagOption on Tag {\n  id\n  name\n  uuid\n  description\n  projectUsageCount\n  goalUsageCount\n  helpPointerUsageCount\n  watcherCount\n}\n\nfragment Tags on TagConnection {\n  edges {\n    node {\n      id\n      uuid\n      name\n      ...Tag\n      ...Tag_createTagOption\n    }\n  }\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment TeamAvatar on Team {\n  id\n  name\n  teamId\n  teamDetails {\n    isVerified\n  }\n  avatarUrl\n}\n\nfragment TeamAvatarWithFollowButton on Team {\n  id\n  teamId\n  name\n  watching\n  ...TeamAvatar\n}\n\nfragment Teams_1QTvbf on Goal {\n  id\n  key\n  canEditMembers\n  teamsV2(first: 20) {\n    edges {\n      node {\n        teamId\n        name\n        ...TeamAvatarWithFollowButton\n        ...GoalTeamByline_1QTvbf\n        id\n        __typename\n      }\n      ...RemoveTeam\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_1TWJ92 on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n    extendedProfile {\n      jobTitle\n    }\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserField on UserCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on UserCustomFieldDefinition {\n      name\n      description\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    edges {\n      node {\n        id\n        aaid\n        ...UserAvatar_1TWJ92\n      }\n    }\n  }\n}\n\nfragment goalTypeName on GoalType {\n  name {\n    __typename\n    ... on GoalTypeCustomName {\n      value\n    }\n    ... on LocalizationField {\n      messageId\n      defaultValue\n    }\n  }\n}\n\nfragment hasMetric on Goal {\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment inlineCurrentValueUpdate on Goal {\n  id\n  metricTargets {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        metric {\n          id\n          type\n          subType\n        }\n      }\n    }\n  }\n}\n\nfragment metricInfoSection on Goal {\n  id\n  uuid\n  ...hasMetric\n  ...metricInfoSectionContent\n}\n\nfragment metricInfoSectionContent on Goal {\n  id\n  ...inlineCurrentValueUpdate\n  ...progressBarMetricTarget\n  ...metricTargetPopup\n  ...metricInfoSectionEmptyState\n  ...progressText\n  ...hasMetric\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    edges {\n      node {\n        progress {\n          percentage\n        }\n        id\n      }\n    }\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          id\n          archived\n          uuid\n          name\n          type\n          subType\n        }\n      }\n    }\n  }\n}\n\nfragment metricInfoSectionEmptyState on Goal {\n  id\n  uuid\n  ...RollupMetricForm\n}\n\nfragment metricInfoSectionNewLozenge on Query {\n  currentUser {\n    onboarding(first: 1, filter: {keys: [GOALS_METRICS_POPUP]}) {\n      edges {\n        node {\n          key\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment metricTargetPopup on Goal {\n  id\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        ...metricTarget_direct\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment metricTarget_direct on MetricTarget {\n  startValue\n  targetValue\n  snapshotValue {\n    value\n    id\n  }\n  metric {\n    id\n    name\n    type\n    subType\n    archived\n  }\n}\n\nfragment parentGoalTypeRestrictions_GoalSidebar on Goal {\n  goalType {\n    allowedParentTypes {\n      edges {\n        node {\n          ari\n          name {\n            __typename\n            ... on GoalTypeCustomName {\n              value\n            }\n            ... on LocalizationField {\n              messageId\n              defaultValue\n            }\n          }\n          icon {\n            key\n          }\n          requiresParentGoal\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment progressBarMetricTarget on Goal {\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          type\n          subType\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment progressText on Goal {\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          type\n          subType\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment subGoalTypeRestrictions_GoalSidebar on Goal {\n  goalType {\n    allowedChildTypes {\n      edges {\n        node {\n          ari\n          name {\n            __typename\n            ... on GoalTypeCustomName {\n              value\n            }\n            ... on LocalizationField {\n              messageId\n              defaultValue\n            }\n          }\n          icon {\n            key\n          }\n          requiresParentGoal\n          id\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "70c632abfb3c72baeb0ab2075d651997";

export default node;
